import { createContext, useContext, useState, useEffect } from 'react';
import { post, get } from '../api/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const CheckAuthentication = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const response = await get('/getUser', token);
      if (response?.message) {
        setUser({
          token,
          ...response.user
        });
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
    } catch (error) {
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    CheckAuthentication();
  }, []);

  const login = async ({ email, password }) => {
    try {
      const response = await post('/signin', { email, password });
      if (response?.token) {
        localStorage.setItem('token', response.token);
        await CheckAuthentication();
        setIsAuthenticated(true);
        
        // Add redirect logic based on email
        const redirectPath = email === 'rrose@babsusa.com' ? '/home' : '/quotes';
        return { success: true, redirect: redirectPath };
      } else {
        return { success: false, error: 'Invalid credentials' };
      }
    } catch (error) {
      return { success: false, error: 'Login failed. Please try again.' };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setIsAuthenticated(false);
  };

  // Add function to check if user is privileged
  const isPrivilegedUser = () => {
    return user?.email === 'rrose@babsusa.com';
  };

  return (
    <AuthContext.Provider value={{
      user,
      isAuthenticated,
      loading,
      login,
      logout,
      isPrivilegedUser
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);